import { Hero } from "../components/Hero";
import { Journey } from "../components/Journey";
import { Marquee } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { Library } from "../components/Library";
import { Founder } from "../components/Founder";
import { Contact } from "../components/Contact";

export default function Home() {
  return (
    <>
      <Hero />
      <Journey />
      <Marquee />
      <Manifesto />
      <Library />
      <Founder />
      <Contact />
    </>
  );
}
